import { render, staticRenderFns } from "./TierProgressBar.vue?vue&type=template&id=5a608dac&scoped=true&"
import script from "./TierProgressBar.vue?vue&type=script&lang=ts&"
export * from "./TierProgressBar.vue?vue&type=script&lang=ts&"
import style0 from "./TierProgressBar.vue?vue&type=style&index=0&id=5a608dac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a608dac",
  null
  
)

export default component.exports